export const DEFAULT_RISK_ENGINE_CODE = `
// Default risk engine code

const riskToScore = {
  low: 10,
  medium: 50,
  high: 80,
  prohibited: 100,
};

// Helpers
function ageInYears(date) {
  const givenDate = new Date(date);
  const today = new Date();
  const difference = today.getTime() - givenDate.getTime();
  return difference / (1000 * 3600 * 24 * 365);
}

// Initialize flags
const prohibitedRiskFlags = {};
const missingDataFlags = {};

// Inputs
const beneficialOwners = $.input.individuals.filter(individual => individual.is_beneficial_owner);
const mainCompany = $.input.companies.find(company => company.type === "main");

// Exit if no main company
if (!mainCompany) $.exit();

// Check registration date
if (!mainCompany.registration_date) {
  missingDataFlags["Missing registration date"] = true;
}

// Calculate maturity score
let maturityScore = riskToScore.high;
if (mainCompany.registration_date) {
  const companyAge = ageInYears(mainCompany.registration_date);
  if (companyAge > 2) {
    maturityScore = riskToScore.low;
  } else if (companyAge < 1) {
    maturityScore = riskToScore.high;
  } else {
    maturityScore = riskToScore.medium;
  }
}

// Industry score calculation
let industryScore = riskToScore.high;
if (!mainCompany.classifications || mainCompany.classifications.length === 0) {
  missingDataFlags["Missing industry"] = true;
} else {
  let highestIndustryScore = 10;

  mainCompany.classifications.forEach(classification => {

    const industryRisk = $.lookup({
      table_key: "industries",
      lookup_column: 'key',
      lookup_value: \`\${classification.type}\${classification.code}\`,
      output_column: "risk",
    });

    $.log(industryRisk);

    // Update the highestIndustryRisk if a higher risk is found
    if (riskToScore[industryRisk] > highestIndustryScore) {
      highestIndustryScore = riskToScore[industryRisk];
    }

  });

  industryScore = highestIndustryScore;

  if (highestIndustryScore === 100) {
    prohibitedRiskFlags["Prohibited industry"] = true;
  }
}


// Registration country score calculation
let registrationCountryScore = 100;
if (mainCompany.country) {
  const riskLevel = $.lookup({
    table_key: "countries",
    lookup_column: "ISO Code",
    lookup_value: mainCompany.country,
    output_column: "Risk level",
  });

  registrationCountryScore = riskToScore[riskLevel] || 100;

  if (riskLevel === "prohibited") {
    prohibitedRiskFlags["Prohibited company country"] = true;
  }
}

// Individuals country score calculation
let individualsCountryScore = 100;

const individualsCountries = [
  ...new Set($.input.individuals.map(individual => individual.address.country)),
].filter(country => country != null);

const individualsCountryRisks = individualsCountries.map(country => {
  if (country) {
    return $.lookup({
      table_key: "countries",
      lookup_column: "ISO Code",
      lookup_value: country,
      output_column: "Risk level",
    });
  }
}).filter(risk => risk != null);

if (individualsCountryRisks.includes("prohibited")) {
  individualsCountryScore = riskToScore.prohibited;
  prohibitedRiskFlags["Prohibited individuals countries"] = true;
} else if (individualsCountryRisks.includes("high")) {
  individualsCountryScore = riskToScore.high;
} else if (individualsCountryRisks.includes("medium")) {
  individualsCountryScore = riskToScore.medium;
} else {
  individualsCountryScore = riskToScore.low;
}

// AML

const positive_hit_types = [];

$.input.individuals.forEach((ind) => {
  // Find the AML check for the current individual
  const aml = ind.checks.find((check) => check.type === "aml");
  // If an AML check is found, proceed to push its data
  if (aml && aml.type === "aml" && aml.data.true_positive_list_types) {
    positive_hit_types.push(...aml.data.true_positive_list_types);
  }
});

if (positive_hit_types.includes("sanction")) prohibitedRiskFlags["AML sanctions"] = true;


// Company blacklist check with improved matching logic
let blacklistScore = riskToScore.low;
let blacklistReason = null;

// Check by company registration number (exact match)
if (mainCompany.registration_number) {
  const registrationRisk = $.lookup({
    table_key: "company_blacklist",
    lookup_column: "Company registration number",
    lookup_value: mainCompany.registration_number,
    output_column: "Risk level",
  });
  
  if (registrationRisk && riskToScore[registrationRisk]) {
    blacklistScore = riskToScore[registrationRisk];
    blacklistReason = "registration";
    
    if (registrationRisk === "prohibited") {
      prohibitedRiskFlags["Blacklisted company (registration number)"] = true;
    }
  }
}


// Score components
const components = {
  "Maturity score": maturityScore,
  "Registration country score": registrationCountryScore,
  "Individuals country score": individualsCountryScore,
  "Industry score": industryScore,
  "Blacklist score": blacklistScore,
};

// Final Score
const score = Math.ceil(
  (maturityScore + registrationCountryScore + industryScore + individualsCountryScore + blacklistScore) / 5
);

const level = Object.keys(prohibitedRiskFlags).length > 0
  ? "prohibited"
  : score >= 80
    ? "high"
    : score < 20
      ? "low"
      : "medium";

$.set_risk({
  level,
  score,
  components,
  flags: { ...prohibitedRiskFlags, ...missingDataFlags },
});
`;
